module.exports = __webpack_public_path__ + "static/media/pthreee.2c3742d1.png";